import { useTranslation } from "react-i18next";
import { Layers, CheckCircle2, FileEdit, Clock, RotateCcw } from "lucide-react";
import { StatCard } from "../../components/neu/StatCard";

const CARDS = [
  { key: "total",            icon: Layers,       tone: "sky" },
  { key: "posted",           icon: CheckCircle2, tone: "emerald" },
  { key: "draft",            icon: FileEdit,     tone: "amber" },
  { key: "approval_pending", icon: Clock,        tone: "orange" },
  { key: "reversed",         icon: RotateCcw,    tone: "rose" },
];

// شريط KPI ثلاثي الأبعاد بأسلوب HELCOO 3D Neu — KPI Tile.
export const JournalStatsBar = ({ stats, active, onSelect }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-5" data-testid="journal-stats">
      {CARDS.map(({ key, icon, tone }) => {
        const filterKey = key === "total" ? "all" : key;
        return (
          <StatCard key={key} testId={`journal-stat-${key}`}
                    label={t(`acct.journal.stats.${key}`)}
                    value={stats?.[key] ?? 0}
                    icon={icon} tone={tone}
                    active={active === filterKey}
                    onClick={() => onSelect(filterKey)} />
        );
      })}
    </div>
  );
};
